<template>

  <v-container
    grid-list-md>
    <v-layout
      row
      wrap
      justify-end
    >
      <v-card
        v-if="carregando"
        flat
        style="overflow: auto; min-height: 200px; width: 100%; box-shadow: 4px 5px 4px #e5e5e5; padding: 10px">
        <v-layout
          v-if="carregando"
          column
          fill-height
          justify-center
          align-center
        >
          <v-progress-circular
            :size="50"
            color="primary"
            indeterminate />
        </v-layout>
      </v-card>
      <template v-else>
        <div style="overflow: auto; min-height: 200px; box-shadow: 4px 5px 4px #e5e5e5; padding: 10px">
          <div
            v-if="idioma === 0"
            aria-labelledby="ui-id-1"
            class="ui-tabs-panel ui-widget-content ui-corner-bottom"
            role="tabpanel"
            aria-expanded="true"
            aria-hidden="false">
            <p
              class="red--text"
              style="font-weight: bold;">* Na nova versão da plataforma do BR-Corte 5.0, não é mais permitido o envio de produtos de empresa para o CQBAL 4.0. Será permitido apenas o envio de alimentos que irão compor a média do banco de alimentos do CQBAL 4.0.</p>
            <p>Prezado usuário,</p>
            <p>Ao nos enviar a análise do seu alimento na opção enviar ao CQBAL, este comporá a média das análises que compõem o banco de dados do CQBAL, garantindo o sigilo de seus dados individuais.</p>
            <p>Se quiser utilizar um alimento ou fonte de minerais que não faz parte de nosso banco de dados, você poderá enviar a composição deste utilizando o formulário na aba 'INFORMAÇÕES NUTRICIONAIS', incluindo obrigatoriamente, no caso de ingredientes de concentrados ou volumosos:</p>
            <ul>
              <li>MS (matéria seca)</li>
              <li>

                MM (matéria mineral)
              </li>
              <li>EE (extrato etéreo)</li>
              <li>PB (proteína bruta)</li>
              <li>Lignina</li>
              <li>
                Pelo menos um:
                <ul>
                  <li>FDN (fibra em detergente neutro) ou</li>
                  <li>FDNcp (fibra em detergente neutro corrigida para cinzas e proteína)</li>
                </ul>
              </li>
              <li>
                Pelo menos um:
                <ul>
                  <li>CNF (carboidratos não fibrosos) ou</li>
                  <li>CNFcp (carboidratos não fibrosos corrigido para cinzas e proteína)</li>
                  <li>Obs: se não tiver o dado de CNF ou CNFcp mas tiver (MO ou MM, EE, PB, FDN ou FDNcp) ok pois será possível calcular o CNF.</li>
                </ul>
              </li>
              <li>Pelo menos um dos seguintes grupos de dados:
                <ul>
                  <li>PBA (fração solúvel da proteína bruta) e</li>
                  <li>PBB (fração potencialmente degradável da proteína bruta) e</li>
                  <li>PBkd (taxa de degradação da fração B)</li>
                </ul>
                ou, para uma kp=5%/h:
                <ul>
                  <li>PDR (proteína degradada no rúmen) e</li>
                  <li>PNDR (proteína não degradada no rúmen)</li>
                </ul>
              </li>
              <li>Pelo menos um dos seguintes grupos de dados:
                <ul>
                  <li>PIDN/MS (proteína insolúvel em detergente neutro na base da matéria seca) e</li>
                  <li>PIDA/MS (proteína insolúvel em detergente ácido na base da matéria seca)</li>
                </ul>
                ou
                <ul>
                  <li>PIDN/PB (proteína insolúvel em detergente neutro na base da proteína bruta) e</li>
                  <li>PIDA/PB (proteína insolúvel em detergente neutro na base da proteína bruta)</li>
                </ul>
                ou
                <ul>
                  <li>NIDN/N (nitrogênio insolúvel em detergente neutro na base do nitrogênio total) e</li>
                  <li>NIDA/N (nitrogênio insolúvel em detergente ácido base do nitrogênio total)</li>
                </ul>
                ou
                <ul>
                  <li>NIDN/MS (nitrogênio insolúvel em detergente neutro na base da matéria seca)</li>
                  <li>NIDA/MS (nitrogênio insolúvel em detergente ácido na base da matéria seca)</li>
                </ul>
              </li>
            </ul>
            <p>Obs: Se o alimento não possuir alguma fração necessária para o cálculo do NDT, usando as equações descritas no BR CORTE (2010), o usuário poderá acrescentar o NDT observado nos dados experimentais (necessário comprovação do valor).</p>
            <p>
              OBS - O usuário deverá encaminhar comprovante desses resultados, que pode ser via registro no MAPA, ou enviar o laudo de análise do alimento de um laboratório de Instituições públicas ( Universidades, Institutos de Pesquisa, EMBRAPA, etc...).<br>
              Além disso, somente poderá ser cadastrado alimentos que não constem da tabela CQBAL resumida.
            </p>
            <p>Se for um premix, núcleo mineral, sal mineral, etc., o usuário deverá apresentar a composição dos macro (Ca, P, Mg, K, Na), expressa em g/kg  e dos microminerais (Co, Cu, I, Mn, Se, Zn), expressos em mg/kg ou ppm.</p>
            <p>Ressaltamos que o usuário fará apenas um pré-cadastro e a composição do seu alimento será avaliada por nosso administrador. Em caso de aprovação, essa será acrescentada ao nosso banco de dados.</p>
          </div>
          <div
            v-if="idioma === 1"
            aria-labelledby="ui-id-1"
            class="ui-tabs-panel ui-widget-content ui-corner-bottom"
            role="tabpanel"
            aria-expanded="true"
            aria-hidden="false">
            <p
              class="red--text"
              style="font-weight: bold;">{{ strings[idioma].aviso_cqbal_permissao }}</p>
            <p>Dear User,</p>
            <p>If you want to use a feed or mineral source that is not part of our database, you can send using the tab 'Data from feed', including mandatory in the case of concentrated or bulky ingredients:</p>
            <ul>
              <li>DM (dry matter)</li>
              <li>
                MM (ash)
              </li>
              <li>EE (ether extract)</li>
              <li>CP (crude protein)</li>
              <li>Lignin</li>
              <li>
                At least one of:
                <ul>
                  <li>NDF (neutral detergent fiber) or</li>
                  <li>NDF (neutral detergent fiber corrected for ash and protein)</li>
                </ul>
              </li>
              <li>
                At least one of:
                <ul>
                  <li>NFC (non-fiber carbohydrates) or</li>
                  <li>CNFCP (non-fiber carbohydrates corrected for ash and protein)</li>
                  <li>Note: if you have no CNF or CNFCP  data but you have (MO or MM, EE, CP, NDF or NDFcp) then  it will be possible to calculate the CNF.</li>
                </ul>
              </li>
              <li>
                At least one of the following groups of data:
                <ul>
                  <li>PBA (soluble fraction of crude protein) and</li>
                  <li>PBB (potentially degradable fraction of crude protein) and</li><li/><li>PBkd (degradation rate of fraction B)</li>
                </ul>
                or, for a = 5% kp / h:
                <ul>
                  <li>RDP (rumen degradable protein) and</li>
                  <li>RUP (rumen undegraded protein)</li>
                </ul>
              </li>
              <li>
                At least one of the following groups of data:
                <ul>
                  <li>NIDP / DM (neutral detergent insoluble protein on dry matter basis) and</li>
                  <li>AIDP / DM (acid detergent insoluble protein on dry matter basis)</li>
                </ul>
                or
                <ul>
                  <li>NIDP / CP (neutral detergent insoluble protein on the basis of crude protein) and</li>
                  <li>AIDP / CP(neutral detergent insoluble protein on the basis of crude protein)</li>
                </ul>
                or
                <ul>
                  <li>NDIN / N (neutral detergent insoluble nitrogen on the basis of total nitrogen) and</li>
                  <li>ADIN / N (acid detergent insoluble nitrogen basis of total nitrogen)</li>
                </ul>
                or
                <ul>
                  <li>NDIN / DM (neutral detergent insoluble nitrogen in dry matter basis)</li>
                  <li>ADIN / DM (acid detergent insoluble nitrogen in dry matter basis)</li>
                </ul>
              </li>
            </ul>
            <p>Note: If the feed does not have some fraction required for the calculation of TDN, using the equations described in BR CORTE (2010), the user can add the TDN observed in experimental data (need to send a proof of value).</p>
            <p>
              NOTE - The user must submit proof of these results. That can be by registration at MAPA, or sending the certificate of analysis of feed of some public institution laboratory (Universities, Research Institutes, etc.).<br>
              Also, it can only be registered feed not available on the summarized table (CQBAL).
            </p>
            <p>If it is a premix mineral, a mineral source for ration formulation, other mineral sources, the user must submit the composition of macro (Ca, P, Mg, K, Na), expressed in g / kg and trace minerals (Co, Cu, I, Mn , Se, Zn), expressed in mg / kg or ppm.</p>
            <p>We emphasize that the user will only complete a pre-registration and the composition of its feed will be evaluated by our administrator. If approved, its composition will be added to our database.</p>
          </div>
          <div
            v-if="idioma === 2"
            aria-labelledby="ui-id-1"
            class="ui-tabs-panel ui-widget-content ui-corner-bottom"
            role="tabpanel"
            aria-expanded="true"
            aria-hidden="false">
            <p
              class="red--text"
              style="font-weight: bold;">* En la nueva versión de la plataforma BR-Corte 5.0, ya no se permite enviar productos de la empresa para CQBAL 4.0. Solo se permitirán los alimentos que se incluirán en el promedio del banco de alimentos CQBAL 4.0.</p>
            <p>Estimado usuario,</p>
            <p>Si desea utilizar un alimento o una fuente de minerales que no forma parte de nuestra base de datos, puede enviarlos mediante la pestaña 'Datos del alimento', incluidos los obligatorios en el caso de ingredientes concentrados o voluminosos:</p>
            <ul>
              <li>MS (materia seca)</li>
              <li>
                MM (ceniza)
              </li>
              <li>EE (extracto de éter)</li>
              <li>PC (proteína cruda)</li>
              <li>Lignina</li>
              <li>
                Al menos uno de:
                <ul>
                  <li>FDN (fibra detergente neutra) o</li>
                  <li>FDN (fibra detergente neutra corregida para cenizas y proteínas)</li>
                </ul>
              </li>
              <li>
                Al menos uno de:
                <ul>
                  <li>NFC (carbohidratos sin fibra) o</li>
                  <li>CNFCP (carbohidratos sin fibra corregidos por cenizas y proteínas)</li>
                  <li>Nota: si no tiene datos CNF o CNFCP pero tiene (MO o MM, EE, CP, NDF o NDFcp), entonces será posible calcular el CNF.</li>
                </ul>
              </li>
              <li>
                Al menos uno de los siguientes grupos de datos:
                <ul>
                  <li>PBA (fracción soluble de proteína cruda) y</li>
                  <li>PBB (fracción potencialmente degradable de proteína cruda) y</li><li/><li>PBkd (tasa de degradación de la fracción B)</li>
                </ul>
                o, para a = 5% kp/h:
                <ul>
                  <li>RDP (proteína degradable en el rumen) y</li>
                  <li>RUP (proteína ruminal no degradada)</li>
                </ul>
              </li>
              <li>
                Al menos uno de los siguientes grupos de datos:
                <ul>
                  <li>PIDN/DM (proteína insoluble en detergente neutro en base a materia seca) y</li>
                  <li>PIDA / DM (proteína insoluble en detergente ácido en base a materia seca)</li>
                </ul>
                o
                <ul>
                  <li>PIDN/CP (proteína insoluble en detergente neutro a base de proteína cruda) y</li>
                  <li>PIDA / CP (proteína insoluble en detergente neutro a base de proteína cruda)</li>
                </ul>
                o
                <ul>
                  <li>NIDN/N (nitrógeno insoluble en detergente neutro sobre la base del nitrógeno total) y</li>
                  <li>NIDA/N (ácido detergente insoluble base nitrogenada del nitrógeno total)</li>
                </ul>
                o
                <ul>
                  <li>NIDN / DM (nitrógeno insoluble en detergente neutro en base a materia seca)</li>
                  <li>NIDA / DM (nitrógeno insoluble en detergente ácido en base a materia seca)</li>
                </ul>
              </li>
            </ul>
            <p>Nota: Si el feed no tiene alguna fracción requerida para el cálculo de NDT, utilizando las ecuaciones descritas en BR CORTE (2010), el usuario puede agregar el TDN observado en los datos experimentales (necesita enviar una prueba de valor) .</p>
            <p>
              NOTA - El usuario debe presentar prueba de estos resultados. Eso puede ser mediante registro en el MAPA, o enviando el certificado de análisis de piensos de laboratorio de alguna institución pública (Universidades, Institutos de Investigación, etc.).<br>
              Además, solo puede ser alimento registrado no disponible en la tabla resumida (CQBAL).
            </p>
            <p>Si se trata de una premezcla mineral, una fuente mineral para formulación de raciones, otras fuentes minerales, el usuario deberá presentar la composición de macro (Ca, P, Mg, K, Na), expresada en g/kg y oligoelementos ( Co, Cu, I, Mn, Se, Zn), expresado en mg/kg o ppm.</p>
            <p>Resaltamos que el usuario solo completará el pre-registro y la composición de su feed será evaluada por nuestro administrador. Si se aprueba, su composición se añadirá a nuestra base de datos.</p>
          </div>
        </div>
        <v-flex>
          <material-card>
            <v-list>
              <div>
                <div class="title">{{ strings[idioma].identificacao_alimento }}</div>
                <template>
                  <v-list-tile
                    class="list-restricoes">
                    <v-list-tile-content>
                      <v-layout
                        align-center
                        justify-space-around
                        row
                        py-2
                        style="width: 100%"
                      >
                        <v-flex
                          xs7
                          sm8
                          md5>
                          <span style="font-weight: 1000;"> {{ strings[idioma].nome_alimento }}: *</span>
                        </v-flex>
                        <v-flex
                          xs5
                          sm4
                          md7>
                          <v-text-field
                            v-model="alimento.nome"
                            color="primary"
                          />
                        </v-flex>
                      </v-layout>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider/>
                  <v-list-tile
                    class="list-restricoes">
                    <v-list-tile-content>
                      <v-layout
                        align-center
                        justify-space-around
                        row
                        py-2
                        style="width: 100%"
                      >
                        <v-flex
                          xs7
                          sm8
                          md5>
                          <span style="font-weight: 500;"> {{ strings[idioma].nome_cientifico }}: </span>
                        </v-flex>
                        <v-flex
                          xs5
                          sm4
                          md7>
                          <v-text-field
                            v-model="alimento.nome_sci"
                            color="primary"
                          />
                        </v-flex>
                      </v-layout>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider/>
                  <v-list-tile
                    class="list-restricoes">
                    <v-list-tile-content>
                      <v-layout
                        align-center
                        justify-space-around
                        row
                        py-2
                        style="width: 100%"
                      >
                        <v-flex
                          xs7
                          sm8
                          md5>
                          <span style="font-weight: 1000;"> {{ strings[idioma].tipo_alimento }}: * </span>
                        </v-flex>
                        <v-flex
                          xs5
                          sm4
                          md7>
                          <v-select
                            key="id"
                            v-model="alimento.tipo"
                            v-bind="binding"
                            :items="tipos.filter(tipo => tipo.id < 900)"
                            :item-text="item => idioma === 0 ? item.nome : idioma === 1 ? item.nome_ingles : item.nome_espanhol"
                            item-value="id"
                            class="text-field-table"
                            dense

                          />
                        </v-flex>
                      </v-layout>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider/>
                </template>
              </div>
            </v-list>
            <v-list>
              <div class="title">{{ strings[idioma].informacoes_nutricionais }}</div>
              <template
                v-for="(ingrediente, index) in ingredientesCompletos"
              >
                <v-list-tile
                  :key="index"
                  :style="limite.id === ingrediente.id ? 'background: grey; color: #fff;': 'background: #fff; color: #000;'"
                  class="list-restricoes">
                  <v-list-tile-content>
                    <v-layout
                      align-center
                      justify-space-around
                      row
                      py-2
                      style="width: 100%"
                    >
                      <v-flex
                        xs7
                        sm8
                        md9>
                        <label :for="ingrediente.id">
                            <span :style="(ingrediente.id !== 'MS' && ingrediente.id !== 'NDT_BRCORTE2016' && ingrediente.id !== 'PB' && alimento.tipo > 8) || ingrediente.id !== 'MS' ? 'font-weight: 500' : 'font-weight: 1000'"> {{ idioma === 0 ? ingrediente.exigencia + ' ('+(ingrediente.codigo ? ingrediente.codigo : ingrediente.sigla)+')' : idioma === 1 ? ingrediente.exigencia_en + ' ('+(ingrediente.codigo_en ? ingrediente.codigo_en : ingrediente.sigla) +')' : ingrediente.exigencia_es + ' ('+(ingrediente.codigo_es ? ingrediente.codigo_es : ingrediente.sigla) +')'}} <span v-if="ingrediente.id === 'MS'">*</span></span>
                        </label>
                      </v-flex>
                      <v-flex
                        xs5
                        sm4
                        md3>
                        <v-text-field
                          v-model="alimento.nutrientes[ingrediente.id]"
                          :id="ingrediente.id"
                          :title="idioma === 0 ? ingrediente.exigencia : idioma === 1 ? ingrediente.exigencia_en : ingrediente.exigencia_es"
                          :suffix="(!ingrediente.unidade_alt) ? (idioma === 0 ? ingrediente.unidade : idioma === 1 ? ingrediente.unidade_en : ingrediente.unidade_es) : (idioma === 0 ? ingrediente.unidade_alt : idioma === 1 ? ingrediente.unidade_alt_en : ingrediente.unidade_alt_es)"
                          :value="alimento.nutrientes[ingrediente.id]? alimento.nutrientes[ingrediente.id] : '0.00'"
                          :color="(limite.id === ingrediente.id) ? 'white' : 'primary'"
                          class="text-field-table text-field-nutrientes"
                          pattern="\d*"
                          inputmode="decimal"
                          @click="loadNutrienteLimite(ingrediente.id)"
                          @focus="loadNutrienteLimite(ingrediente.id)"
                          @change="val => changeIngrediente(ingrediente.id, val, ingrediente.unidade)"
                        />
                        <!-- AB#5427
                           <small
                          v-if="limite.id === ingrediente.id"
                          style="color: #fff">{{ strings[idioma].minimo_exigencia }}: {{ limite.menor > 0 ? limite.menor : 0 }}; {{ strings[idioma].maximo_exigencia }}: {{ limite.maior > 0 ? limite.maior : 100 }}</small> -->
                      </v-flex>
                    </v-layout>
                  </v-list-tile-content>
                </v-list-tile>

              </template>
            </v-list>
            <v-layout
              row
              wrap
              justify-end
            >
              <p
                class="red--text"
                style="font-weight: bold;">{{ strings[idioma].aviso_cqbal_permissao }}</p>
              <v-btn
                color="primary"
                @click="envia()"
              >
                {{ strings[idioma].salvar }}
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </v-layout>
          </material-card>
        </v-flex>
      </template>
    </v-layout>
  </v-container>

</template>
<script>
import { mapState } from 'vuex'
import { getAlimentosEmpresa, updateData, createMD5, getAlimentos } from '@/utils/utils'

export default {
  data: () => ({
    limite: { sigla: null, menor: 0, maior: 100 },
    alimentoBase: null,
    etapaAlimentoBase: true,
    alimento: {
      nome: '',
      nome_sci: '',
      tipo: null,
      nutrientes: {},
      user: {}
    },
    step: 1,
    loadingAlimentos: false,
    escolha: false,
    basePessoal: false,
    stepComplete: [false, false],
    alimentosUsuario: [],
    alimentoClick: [],
    arrayTable: [
      {
        id: 'ok'
      }
    ],
    calculandoDieta: false,
    calculandoNutrientes: false,
    changeMinMax: false,
    dialogNutrientes: false,
    dietaOtimizada: false,
    dietaSemiOtima: false,
    editarExigencias: false,
    loadingStep2: false,
    indexAlimentoDialog: 0,
    menu1: false,
    menu2: false,
    menu3: false,
    menu4: false,
    open: [],
    pagination: {
      rowsPerPage: 20,
      sortBy: null,
      descending: false,
      page: 1,
      totalItems: 0
    },
    recalculandoExigencias: false,
    search: null,
    searchRestricao: null,
    fixaVC: false,
    treeAlimentos: [],
    validAnimal: false,
    selected: false,
    indetermined: false,
    volumososSelecionados: [],
    concentradoSelecionados: [],
    selecionaComuns: false,
    expandeArvore: false,
    travaSelectAll: false,
    info: false,
    carregando: false
  }),
  computed: {
    ...mapState('app', ['strings', 'idioma', 'user', 'ingredientes', 'ingredientesCompletos', 'optionsNumber', 'alimentos_selecionados', 'categorias_alimentos', 'alert', 'empresa', 'acesso_premium', 'tipos']),

    binding () {
      const binding = {}
      if (this.$vuetify.breakpoint.mdAndUp) binding.row = true
      else binding.row = false
      return binding
    },
    selectable () {
      return this.open.length > 0
    },
    heightCard () {
      return String(this.$vuetify.breakpoint.height - 289) + 'px'
    },
    heightOverflow () {
      return 'max-height: ' + String(this.$vuetify.breakpoint.height - 120) + 'px; overflow: auto;'
    }
  },
  watch: {
    'loadingAlimentos' (val) {
      let loading = val
      this.$store.commit('setLoading', loading)
    },
    'alimentoClick' (val) {
      this.alimentoBase = val
      console.log(this.alimentoBase)
    },
    'treeAlimentos' (val) {
      if (Math.abs(this.alimentos_selecionados.length - val.length) > 2) {
        this.treeAlimentos = this.alimentos_selecionados
        return
      }
      this.$store.commit('setAlimentosSelecionados', val)
      this.pagination.totalItems = this.alimentos_selecionados.length
      this.stepComplete[0] = val.length !== 0
    },
    'open' (val) {
      if ((this.search === '' || this.search === null) && val.length > 1) {
        this.open = [val[val.length - 1]]
      }
    }
  },
  created () {
    this.$store.dispatch('getTipos')
    this.axios.post('composicao/nutrientesLimite').then((res) => {
      console.log(res)
    })
    this.escolha = this.acesso_premium
    this.loadAlimentosDieta()
    if (!this.$store.state.app.categorias_alimentos) {
      this.loadingAlimentos = true
      this.axios.post('alimentos/lastUpdateAt', {}).then(response => {
        let lastUpdate = parseInt(response.data.data[1])
        if (lastUpdate === parseInt(localStorage.getItem('lastUpdate'))) {
          let tipos = JSON.parse(localStorage.getItem('tipos'))
          let alimentos = JSON.parse(localStorage.getItem('alimentos'))
          this.$store.commit('setAlimentos', { tipos: tipos, alimentos: alimentos })
          this.loadingAlimentos = false
        } else {
          this.axios.post('tipos', {}).then(response => {
            let tipos = response.data.data
            localStorage.setItem('tipos', JSON.stringify(tipos))
            this.axios.post('relatorio/alimentosBrCorte', {}).then(response => {
              localStorage.setItem('alimentos', JSON.stringify(response.data.data))
              this.$store.commit('setAlimentos', { tipos: tipos, alimentos: response.data.data })
              this.loadingAlimentos = false
              localStorage.setItem('lastUpdate', lastUpdate)
            }).catch(error => {
              console.log(error)
            })
          })
        }
      })
    }
    let meusAlimentos = []
    this.axios.post('alimentos/getAlimentosUsuario', { id_pessoa: this.user.id }).then((res) => {
      for (let al of res.data.data) {
        let alim = Object.assign({}, al)
        alim['nutrientes'] = JSON.parse(al.nutrientes)
        meusAlimentos.push(alim)
      }
      this.alimentosUsuario = meusAlimentos
      this.$store.commit('setAlimentosUsuario', { alimentos: meusAlimentos })
    })
  },
  methods: {
    convertMStoGKG (val) {
      return val * 10
    },
    convertGKGtoMS (val) {
      return val / 10
    },
    convertMacroToMS (alimento) {
      let nutrientes = JSON.parse(JSON.stringify(alimento.nutrientes))
      for (let ingrediente of Object.values(this.ingredientesCompletos)) {
        if (!ingrediente.fator_conv_alt) continue
        let val = null
        if (!nutrientes[ingrediente.id] || nutrientes[ingrediente.id] === null) {
          val = 0
        } else {
          val = this.convertGKGtoMS(String(nutrientes[ingrediente.id]).replace(this.strings[this.idioma].separador_float, '.'))
        }
        if (val === 0) nutrientes[ingrediente.id] = ''
        else nutrientes[ingrediente.id] = val.toFixed(3).replace('.', this.strings[this.idioma].separador_float)
      }

      return { ...nutrientes }
    },
    convertMacroToGKG (alimento) {
      let nutrientes = JSON.parse(JSON.stringify(alimento.nutrientes))
      for (let ingrediente of Object.values(this.ingredientesCompletos)) {
        if (!ingrediente.fator_conv_alt) continue
        let val = null
        if (!nutrientes[ingrediente.id] || nutrientes[ingrediente.id] === null) {
          val = 0
        } else {
          val = this.convertMStoGKG(String(nutrientes[ingrediente.id]).replace(this.strings[this.idioma].separador_float, '.'))
        }
        if (val === 0) nutrientes[ingrediente.id] = ''
        else nutrientes[ingrediente.id] = val.toFixed(3).replace('.', this.strings[this.idioma].separador_float)
      }
      return { ...nutrientes }
    },
    loadNutrienteLimite (sigla) {
      this.limite['id'] = sigla
      this.axios.post('composicao/nutrienteLimite', { sigla: sigla }).then(res => {
        this.limite = res.data.data
        this.limite['id'] = sigla
      }).catch(err => {
        this.limite = {}
        this.limite.menor = 0
        this.limite.maior = 100
        this.limite['id'] = sigla
        console.log(err)
      })
    },
    async loadAlimentosDieta () {
      this.loadingAlimentos = true
      this.loadingStep1 = true

      getAlimentos(this.$store, this.axios).then(r => {
        this.loadingAlimentos = false
        this.loadingStep1 = false
        this.loadData()
      }).catch((e) => {
        this.loadingAlimentos = false
        this.loadingStep1 = false
        this.loadData()
      })
    },
    go (url) {
      window.location.href = url
    },
    mudarEmpresa () {
      sessionStorage.removeItem('empresaAdm')
      this.go('/empresa')
    },
    enviarEmpresa () {
      sessionStorage.removeItem('empresaAdm')
      sessionStorage.removeItem('alimentoCarregado')
      this.go('/empresa/add-alimento')
    },
    resetAlimento () {
      this.alimento = {
        nome: '',
        nome_sci: '',
        tipo: null,
        nutrientes: {},
        user: {}
      }
    },
    openAlimento (al) {
      let alimento = Object.assign({}, al)
      alimento.nome_sci = alimento.nome_cientifico
      alimento.tipo = alimento.id_tipo
      for (let nut in alimento.nutrientes) {
        alimento.nutrientes[nut] = parseFloat(alimento.nutrientes[nut]).toFixed(2)
        if (!isNaN(alimento.nutrientes[nut])) {
          alimento.nutrientes[nut] = alimento.nutrientes[nut].replace('.', this.strings[this.idioma].separador_float)
        } else {
          alimento.nutrientes[nut] = ''
        }
      }
      this.alimento = alimento
      this.stepComplete[0] = true
      this.step = 2
      this.basePessoal = true
      sessionStorage.setItem('alimentoCarregado', JSON.stringify(alimento))
      // window.location.href = '/empresa/add-alimento'
    },
    removeAlimento (al) {
      delete this.remove
      if (confirm(this.strings[this.idioma].msg_remove)) {
        this.axios.post('alimentos/removeAlimento', { id: al.id }).then((res) => {
          let meusAlimentos = []
          this.axios.post('alimentos/getAlimentosUsuario', { id_pessoa: this.user.id }).then((res) => {
            for (let al of res.data.data) {
              let alim = Object.assign({}, al)
              alim['nutrientes'] = JSON.parse(al.nutrientes)
              meusAlimentos.push(alim)
            }
            this.alimentosUsuario = meusAlimentos
            // this.$store.commit('setAlimentosUsuario', { alimentos: meusAlimentos })
          })
        }).catch(() => alert('Erro, ao remover o alimento!!!'))
      }
    },
    changeIngrediente (ingrediente, nutriente, unidade) {
      if (nutriente === null || nutriente === undefined) {
        nutriente = 0
      }
      if (typeof nutriente === 'number') {
        nutriente = nutriente.toFixed(2).replace('.', this.strings[this.idioma].separador_float)
      }
      let val = parseFloat(nutriente.replace(this.strings[this.idioma].separador_float, '.'))
      this.alimento.nutrientes[ingrediente] = isNaN(this.alimento.nutrientes[ingrediente]) ? 0 : this.alimento.nutrientes[ingrediente]
      this.alimento.nutrientes[ingrediente] = parseFloat(isNaN(parseFloat(val)) ? 0 : val).toFixed(2).replace('.', this.strings[this.idioma].separador_float)
      if (unidade === '%' && val > 100) {
        let msg = this.strings[this.idioma].cuidado_valores_maiores_100
        let time = 6000
        this.$store.commit('openErrorAlert', { msg, time })
      }

      /* if (unidade === '%') {
        this.alimento.nutrientes[ingrediente] = this.idioma === 0 ? (val > 100 ? 100 : (val < 0 || isNaN(val)) ? 0 : val).toFixed(2).replace(',', '').replace('.', ',') : (val > 100 ? 100 : (val < 0) ? 0 : val).toFixed(2).replace('.', ',')
      } else {
        this.alimento.nutrientes[ingrediente] = this.idioma === 0 ? ((val < 0 || isNaN(val)) ? 0 : val).toFixed(2).replace(',', '').replace('.', ',') : ((val < 0 || isNaN(val)) ? 0 : val).toFixed(2).replace('.', ',')
      } */
      return this.alimento.nutrientes[ingrediente]
    },
    parseString (valor, idioma) {
      if ((idioma === 0 || idioma === 2) && valor && valor !== '-') {
        if (valor[valor.length - 3] === '.' || valor[valor.length - 2] === '.') return parseFloat(valor)
        return parseFloat(valor.replace(/[.]/g, '').replace(/[,]/g, '.'))
      } else if (idioma === 1 && valor && valor !== '-') {
        if (valor[valor.length - 3] === ',' || valor[valor.length - 2] === ',') return parseFloat(valor.replace(/[,]/g, '.'))
        else return parseFloat(valor)
      } else if (valor && valor !== '-') {
        return parseFloat(valor.replace(/[,]/g, ''))
      }
      return 0
    },

    enviaBasePessoal () {
      let ms = parseFloat(String(this.alimento.nutrientes.MS).replace(this.strings[this.idioma].separador_float, '.'))
      let assert = this.alimento.nome.length >= 3 && this.alimento.tipo !== null && !isNaN(ms) && ms > 0.0
      if (!assert) {
        let msg = this.strings[this.idioma].campos_faltantes + ((this.alimento.nome.length < 3) ? this.strings[this.idioma].alimento_minimo_caracteres : '')
        let time = 6000
        this.$store.commit('openErrorAlert', { msg, time })
        let title = this.strings[this.idioma].atencao_erro
        this.$store.commit('openOKModal', {
          title,
          msg,
          error: true
        })

        return
      }
      this.alimento.user = this.user
      this.alimento.id_pessoa = (this.alimento.id_pessoa) ? this.alimento.id_pessoa : this.user.id
      this.alimento.nome_ingles = this.alimento.nome_espanhol = this.alimento.nome
      this.alimento.nome_cientifico = this.alimento.nome_sci
      // this.alimento.id_empresa = this.empresa.id
      delete this.alimento.nome_sci
      delete this.alimento.nutrientes_raw
      this.alimento.id_tipo = this.alimento.tipo
      let nutrientes = Object.assign({}, this.alimento.nutrientes)
      for (let ingredienteID in this.ingredientesCompletos) {
        let ingrediente = this.ingredientesCompletos[ingredienteID]
        if (!nutrientes[ingrediente.id]) nutrientes[ingrediente.id] = '0'
        nutrientes[ingrediente.id] = parseFloat(String(nutrientes[ingrediente.id]).replace(this.strings[this.idioma].separador_float, '.'))
      }
      this.alimento.nutrientes = JSON.stringify(nutrientes)
      delete this.alimento.tipo
      delete this.alimento.user
      delete this.alimento.empresa
      this.axios.post('empresa/addAlimento', { alimento: this.alimento }).then((res) => {
        let msg = this.strings[this.idioma].cadastrado
        let title = ''
        this.$store.commit('openOKModal', { title, msg })
        setTimeout(() => {
          window.location.href = '/enviar-alimento'
        }, 200)
        console.log(res)
      }).catch((err) => {
        console.log(err)
      })
      console.log(this.alimento)
    },
    envia () {
      let ms = parseFloat(String(this.alimento.nutrientes.MS).replace(this.strings[this.idioma].separador_float, '.'))
      let assert = this.alimento.nome.length >= 3 && this.alimento.tipo !== null && !isNaN(ms) && ms > 0.0
      if (!assert) {
        let msg = this.strings[this.idioma].campos_faltantes + ((this.alimento.nome.length < 3) ? this.strings[this.idioma].alimento_minimo_caracteres : '')
        let time = 6000
        this.$store.commit('openErrorAlert', { msg, time })
        let title = this.strings[this.idioma].atencao_erro
        this.$store.commit('openOKModal', {
          title,
          msg,
          error: true
        })

        return
      }
      this.alimento.user = this.user
      localStorage.setItem('alimento', this.alimento)
      let alimento = JSON.parse(JSON.stringify(this.alimento))
      let user = this.user
      // converter g/kg para %MS
      this.alimento.nutrientes = this.convertMacroToMS(this.alimento)
      // -----------------------
      if (this.basePessoal) {
        return this.enviaBasePessoal()
      }

      let nutrientes = Object.assign({}, this.alimento.nutrientes)
      let nutNormalizado = {}
      for (let ingredienteID in this.ingredientesCompletos) {
        let ingrediente = this.ingredientesCompletos[ingredienteID]
        if (!nutrientes[ingrediente.id]) nutrientes[ingrediente.id] = '0'
        nutrientes[ingrediente.id] = parseFloat(String(nutrientes[ingrediente.id]).replace(this.strings[this.idioma].separador_float, '.'))
        nutNormalizado[(ingrediente.SYS) ? ingrediente.SYS : ingrediente.id] = nutrientes[ingrediente.id]
      }
      alimento.nutrientes = nutNormalizado
      this.carregando = true
      this.axios.post('cqbal/enviaAlimento', { 'alimento': alimento, 'user': user }).then(response => {
        let msg = this.strings[this.idioma].alimento_enviado
        // let time = 6000
        // this.$store.commit('openSuccessAlert', { msg, time })
        let title = this.strings[this.idioma].cadastrado
        this.$store.commit('openOKModal', {
          title,
          msg,
          error: false
        })
        this.carregando = false
        setTimeout(() => {
          window.location.href = '/enviar-alimento'
        }, 500)
      })
    }
  }
}
</script>
